import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFirebaseStore } from 'freedom-shared';

import type { LocaleKey, PromocodeModalRemoteConfig } from './types';

function normalizeLocale(rawLocale: string): LocaleKey {
  const normalized = rawLocale.split('-')[0];

  if (normalized === 'kk' || normalized === 'en') {
    return normalized;
  }

  return 'ru';
}

export function usePromocodeFromQuery() {
  const route = useRoute();

  const promocode = computed<string | null>(() => {
    const raw = route.query.promocode;

    if (typeof raw !== 'string') {
      return null;
    }

    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed : null;
  });

  return {
    promocode,
  };
}

export function usePromocodeModal() {
  const { promocode } = usePromocodeFromQuery();
  const { serializedRemoteConfig } = storeToRefs(useFirebaseStore());
  const { locale } = useI18n();

  const config = computed<PromocodeModalRemoteConfig | undefined>(() => {
    const raw = serializedRemoteConfig.value?.avfree_promocode_modal;

    if (!raw || typeof raw !== 'object') {
      return undefined;
    }

    return raw as PromocodeModalRemoteConfig;
  });

  const isEnabled = computed(() => config.value?.isEnabled === true);

  const bannerImage = computed<string | null>(() => {
    const images = config.value?.bannerImage;

    if (!images) {
      return null;
    }

    const lang = normalizeLocale(locale.value);
    return images[lang] ?? images.ru ?? null;
  });

  const shouldOpen = computed(
    () => isEnabled.value && promocode.value !== null,
  );

  return {
    promocode,
    isEnabled,
    bannerImage,
    shouldOpen,
  };
}
